import React from 'react';
import PropTypes from 'prop-types';
import { Typography, TextField, Grid } from '@material-ui/core';

class PeselFragment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: props.peselFragmentMask.map(() => ''),
    };
  }

  /*handleKeyPress = (e, fieldName) => {
    const fieldNumber = fieldName.replace('pesel', '');
    const nextFieldNumber = parseInt(fieldNumber) + 1;
    //this.refs[`pesel${nextFieldNumber}`].focus();
  }*/

  handleChange = (index, value) => {
    const newValues = [...this.state.values];
    if (!value || (value.length === 1 && Number.isInteger(parseInt(value)))) {
      newValues[index] = value;
      this.setState(
        { values: newValues },
        () => {
          if (this.props.peselFragmentMask.filter(v => v).length === this.state.values.filter(v => v).length) {
            this.props.input.onChange(this.state.values.map(v => v ? v : '_').join(''));
          } else {
            this.props.input.onChange('');
          }
          this.props.input.onBlur();
        }
      );
    }

  };

  render() {
    const {
      label,
      meta: { touched, error },
      disabled,
      peselFragmentMask,
      helperText
    } = this.props;
    const { values } = this.state;

    return (
      <div style={{marginTop: 18, margiBottom: 12}}>
        <Typography variant="caption">{label}</Typography>
        <Grid container spacing={1} justify="flex-start" alignItems="center">
          {peselFragmentMask.map((value, index) => (
            <Grid item key={index}>
              <TextField
              variant="outlined"
              margin="dense"
                disabled={disabled || !value}
                value={values[index]}
                onChange={e => this.handleChange(index, e.target.value)}
                name={`pesel${index}`}
                ref={`pesel${index}`}
                inputProps={{ref: this.name}}
                //onKeyPress={e => this.handleKeyPress(e, `pesel${index}`)}
                style={!value ? { backgroundColor: '#f1f1f1', width: 40 } : { width: 40 }}
              />
            </Grid>
          ))}
        </Grid>
        {touched && error ? <Typography variant="caption" color="error">{error}</Typography> : null}
        {helperText && <Typography variant="caption" component="div">{helperText}</Typography>}
      </div>
    );
  }
}

PeselFragment.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
  peselFragmentMask: PropTypes.array.isRequired,
  helperText: PropTypes.string,
};

export default PeselFragment;



// WEBPACK FOOTER //
// ./src/components/form/PeselFragmentField.js